import React from "react";
import { useNavigate } from "react-router-dom";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import SignUpModal, { id as SignUpModalId } from "../SignUpModal/SignUpModal";
// import LogInModal, { id as LogInModalId } from "../LogInModal/LogInModal";
import { showModal, logout } from "../../Slices/sessionSlice";
import CreateProject, {
  id as CreateProjectId,
} from "../CreateProject/CreateProject";
import EditProject, { id as EditProjectId } from "../EditProject/EditProject";
import CreateTask, { id as CreateTaskId } from "../CreateTask/CreateTask";
import styles from "./Navbar.module.css";

const NavBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sessionUser, activeModal } = useSelector(
    (state) => state.sessionSlice
  );

  const CanStay = ({ path, label }) => {
    if (window.location.href.split(window.location.host)[1].includes(path)) {
      return (
        <>
          <Nav.Link active href={path}>
            {label}
          </Nav.Link>
        </>
      );
    }
    return (
      <>
        <Nav.Link href={path}>{label}</Nav.Link>
      </>
    );
  };

  const getOrgAdminDropdown = () => {
    if (
      window.location.href
        .split(window.location.host)
        .at(1)
        .includes("org-admin")
    ) {
      return (
        <>
          <NavDropdown active title="Org Admin" id="basic-nav-dropdown">
            <NavDropdown.Item href="/org-admin/reports">
              Reports
            </NavDropdown.Item>
            <NavDropdown.Item href="/org-admin/dashboard">
              Dashboard
            </NavDropdown.Item>
            <NavDropdown.Item href="/org-admin/project-assignment">
              Project Assignment
            </NavDropdown.Item>
          </NavDropdown>
        </>
      );
    } else {
      return (
        <>
          <NavDropdown title="Org Admin" id="basic-nav-dropdown">
            <NavDropdown.Item href="/org-admin/reports">
              Reports
            </NavDropdown.Item>
            <NavDropdown.Item href="/org-admin/dashboard">
              Dashboard
            </NavDropdown.Item>
            <NavDropdown.Item href="/org-admin/project-assignment">
              Project Assignment
            </NavDropdown.Item>
          </NavDropdown>
        </>
      );
    }
  };

  return (
    <>
      <Navbar collapseOnSelect expand="lg" bg="white" variant="light" className={styles.navbar}>
        <Container fluid={true}>
          <Navbar.Brand href="/">
            <span className="h5">Tracker</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto pe-md-5 ">
              {sessionUser && sessionUser.candidates.length !== 0 && (
                <>
                  <CanStay
                    path={"/candidateScreenshots"}
                    label={"Screenshots"}
                  />
                  <CanStay path={"/candidateDashboard"} label={"Dashboard"} />
                </>
              )}
              {/*-------------------- Org Admin ---------------------- */}
              {sessionUser &&
                sessionUser.roles.includes("OrgAdmin") &&
                getOrgAdminDropdown()}
              {/*-------------------- Supervisor ---------------------- */}

              {sessionUser && sessionUser.roles.includes("Supervisor") && (
                <>
                  <CanStay
                    path={"/supervisor/dashboard"}
                    label={"Supervisor Dashboard"}
                  />
                </>
              )}

              {/* --------------------- Super Admin ---------------------- */}
              {sessionUser && sessionUser.roles.includes("super-admin") && (
                <>
                  <CanStay path={"/admin/createUser"} label={"Create User"} />
                  <CanStay path={"/admin/editUser"} label={"Edit User"} />
                </>
              )}

              {/* --------------------- Admin ---------------------- */}
              {sessionUser && sessionUser.roles.includes("admin") && (
                <>
                  <CanStay path={"/admin/createUser"} label={"Create User"} />
                  <CanStay path={"/admin/editUser"} label={"Edit User"} />
                </>
              )}

              {!sessionUser && (
                <>
                  <Nav.Item>
                    <Button
                      className={styles.btnSignIn}
                      onClick={() =>{
                        // dispatch(showModal({ id: LogInModalId, data: null }))
                        navigate("/sign-in")
                      }}
                    >
                      Sign In
                    </Button>
                  </Nav.Item>
                </>
              )}
              {/* ----------------- User ----------------------------------- */}
              {sessionUser && sessionUser.firstName && sessionUser.lastName && (
                <>
                  <NavDropdown
                    className="ml-auto"
                    title={`${sessionUser.firstName} ${sessionUser.lastName}`}
                    id="basic-nav-dropdown"
                  >
                    <NavDropdown.Item
                      href="#"
                      onClick={() => dispatch(logout())}
                    >
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
          {/* {activeModal && activeModal.id === LogInModalId && <LogInModal />} */}
          {activeModal && activeModal.id === SignUpModalId && <SignUpModal />}
          {activeModal && activeModal.id === CreateProjectId && (
            <CreateProject />
          )}
          {activeModal && activeModal.id === EditProjectId && <EditProject />}
          {activeModal && activeModal.id === CreateTaskId && (
            <CreateTask data={activeModal.data} />
          )}
        </Container>
      </Navbar>
    </>
  );
};

export default NavBar;
